"use client";
import { EducationDisplay } from "@/features/profile/tutor/components/profile-page/EducationSection/EducationDisplay.tsx";

export const EducationSection = () => {
  return (
    <div>
      <EducationDisplay />
    </div>
  );
};
